"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontendIdpFactory = void 0;
__exportStar(require("./models"), exports);
const drivers_1 = require("./drivers");
class FrontendIdpFactory {
    static createClient(driver) {
        let client;
        switch (driver) {
            case 'cognito':
                client = new drivers_1.CognitoFrontend();
                break;
            default:
                client = null;
        }
        return client;
    }
}
exports.FrontendIdpFactory = FrontendIdpFactory;
//# sourceMappingURL=index.js.map